export default __webpack_public_path__ + "static/media/icon_testimonial.9a3b68f0.svg";